export const INIT_REQUEST = "INIT_REQUEST";
export const INIT_SUCCESS = "INIT_SUCCESS";
export const INIT_FAILURE = "INIT_FAILURE";
export const INIT_HELP_STATUS = "INIT_HELP_STATUS";

export const INIT_INTERNET_CONNECTION_STATUS =
  "INIT_INTERNET_CONNECTION_STATUS";

export const COMPLETE_USER_INFO_CONFIRM_DATA =
  "COMPLETE_USER_INFO_CONFIRM_DATA";
export const COMPLETE_USER_INFO_CONFIRM_CLOSE =
  "COMPLETE_USER_INFO_CONFIRM_CLOSE";

export const COMPLETE_PROJECT_INFO_CONFIRM_DATA =
  "COMPLETE_PROJECT_INFO_CONFIRM_DATA";
export const COMPLETE_PROJECT_INFO_CONFIRM_CLOSE =
  "COMPLETE_PROJECT_INFO_CONFIRM_CLOSE";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const REGISTER_REQUEST = "REGISTER_REQUEST";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILURE = "REGISTER_FAILURE";
export const REFERENCE_CODE_REQUEST = "REFERENCE_CODE_REQUEST";
export const REFERENCE_CODE_SUCCESS = "REFERENCE_CODE_SUCCESS";
export const REFERENCE_CODE_FAILURE = "REFERENCE_CODE_FAILURE";
export const VERIFY_REQUEST = "VERIFY_REQUEST";
export const VERIFY_SUCCESS = "VERIFY_SUCCESS";
export const VERIFY_FAILURE = "VERIFY_FAILURE";
export const FORGET_REQUEST = "FORGET_REQUEST";
export const FORGET_SUCCESS = "FORGET_SUCCESS";
export const FORGET_FAILURE = "FORGET_FAILURE";
export const FORGET_VERIFY_REQUEST = "FORGET_VERIFY_REQUEST";
export const FORGET_VERIFY_SUCCESS = "FORGET_VERIFY_SUCCESS";
export const FORGET_VERIFY_FAILURE = "FORGET_VERIFY_FAILURE";
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const PROJECT_USERS_LIST_REQUEST = "PROJECT_USERS_LIST_REQUEST";
export const PROJECT_USERS_LIST_SUCCESS = "PROJECT_USERS_LIST_SUCCESS";
export const PROJECT_USERS_LIST_FAILURE = "PROJECT_USERS_LIST_FAILURE";
export const PROJECT_LIST_REQUEST = "PROJECT_LIST_REQUEST";
export const PROJECT_LIST_SUCCESS = "PROJECT_LIST_SUCCESS";
export const PROJECT_LIST_FAILURE = "PROJECT_LIST_FAILURE";
export const PROJECT_STORE_REQUEST = "PROJECT_STORE_REQUEST";
export const PROJECT_STORE_SUCCESS = "PROJECT_STORE_SUCCESS";
export const PROJECT_STORE_FAILURE = "PROJECT_STORE_FAILURE";
export const PROJECT_DELETE_REQUEST = "PROJECT_DELETE_REQUEST";
export const PROJECT_DELETE_SUCCESS = "PROJECT_DELETE_SUCCESS";
export const PROJECT_DELETE_FAILURE = "PROJECT_DELETE_FAILURE";
export const PROJECT_UPDATE_REQUEST = "PROJECT_UPDATE_REQUEST";
export const PROJECT_UPDATE_SUCCESS = "PROJECT_UPDATE_SUCCESS";
export const PROJECT_UPDATE_FAILURE = "PROJECT_UPDATE_FAILURE";
export const PROJECT_ACCEPT_REQUEST = "PROJECT_ACCEPT_REQUEST";
export const PROJECT_ACCEPT_SUCCESS = "PROJECT_ACCEPT_SUCCESS";
export const PROJECT_ACCEPT_FAILURE = "PROJECT_ACCEPT_FAILURE";

export const PROJECT_REJECT_REQUEST = "PROJECT_REJECT_REQUEST";
export const PROJECT_REJECT_SUCCESS = "PROJECT_REJECT_SUCCESS";
export const PROJECT_REJECT_FAILURE = "PROJECT_REJECT_FAILURE";

export const PROJECT_ARCHIVE_REQUEST = "PROJECT_ARCHIVE_REQUEST";
export const PROJECT_ARCHIVE_SUCCESS = "PROJECT_ARCHIVE_SUCCESS";
export const PROJECT_ARCHIVE_FAILURE = "PROJECT_ARCHIVE_FAILURE";

export const PROJECT_TYPES_REQUEST = "PROJECT_TYPES_REQUEST";
export const PROJECT_TYPES_SUCCESS = "PROJECT_TYPES_SUCCESS";
export const PROJECT_TYPES_FAILURE = "PROJECT_TYPES_FAILURE";

export const PROJECT_ANSWER_INVITATION_REQUEST =
  "PROJECT_ANSWER_INVITATION_REQUEST";
export const PROJECT_ANSWER_INVITATION_SUCCESS =
  "PROJECT_ANSWER_INVITATION_SUCCESS";
export const PROJECT_ANSWER_INVITATION_FAILURE =
  "PROJECT_ANSWER_INVITATION_FAILURE";

export const PROJECT_CLEAR_LIST = "PROJECT_CLEAR_LIST";

export const PROJECT_REINITIALIZED_PENDING_LIST =
  "PROJECT_REINITIALIZED_PENDING_LIST";

export const SET_PROJECT_DELETE_ARCHIVE_CONFIRM_INFO =
  "SET_PROJECT_DELETE_ARCHIVE_CONFIRM_INFO";
export const SHOW_USERNAME_MODAL = "SHOW_USERNAME_MODAL";
export const HIDE_USERNAME_MODAL = "HIDE_USERNAME_MODAL";

export const SET_NOTIFICATION_COUNT = "SET_NOTIFICATION_COUNT";

export const NOTICE_LIST_REQUEST = "NOTICE_LIST_REQUEST";
export const NOTICE_LIST_SUCCESS = "NOTICE_LIST_SUCCESS";
export const NOTICE_LIST_FAILURE = "NOTICE_LIST_FAILURE";

export const NOTICE_READ_REQUEST = "NOTICE_READ_REQUEST";
export const NOTICE_READ_SUCCESS = "NOTICE_READ_SUCCESS";
export const NOTICE_READ_FAILURE = "NOTICE_READ_FAILURE";

export const NOTIFICATION_REMOVE_REQUEST = "NOTIFICATION_REMOVE_REQUEST";
export const NOTIFICATION_REMOVE_SUCCESS = "NOTIFICATION_REMOVE_SUCCESS";
export const NOTIFICATION_REMOVE_FAILURE = "NOTIFICATION_REMOVE_FAILURE";

export const PROVINCE_REQUEST = "PROVINCE_REQUEST";
export const PROVINCE_SUCCESS = "PROVINCE_SUCCESS";
export const PROVINCE_FAILURE = "PROVINCE_FAILURE";
export const CITY_REQUEST = "CITY_REQUEST";
export const CITY_SUCCESS = "CITY_SUCCESS";
export const CITY_FAILURE = "CITY_FAILURE";
export const CITY_CLEAN_LIST = "CITY_CLEAN_LIST";

export const PETTY_CASHIER_GET_ACCOUNT_REVIEW_REQUEST =
  "PETTY_CASHIER_GET_ACCOUNT_REVIEW_REQUEST";
export const PETTY_CASHIER_GET_ACCOUNT_REVIEW_SUCCESS =
  "PETTY_CASHIER_GET_ACCOUNT_REVIEW_SUCCESS";
export const PETTY_CASHIER_GET_ACCOUNT_REVIEW_FAILURE =
  "PETTY_CASHIER_GET_ACCOUNT_REVIEW_FAILURE";

export const MANAGER_GET_ACCOUNT_REVIEW_REQUEST =
  "MANAGER_GET_ACCOUNT_REVIEW_REQUEST";
export const MANAGER_GET_ACCOUNT_REVIEW_SUCCESS =
  "MANAGER_GET_ACCOUNT_REVIEW_SUCCESS";
export const MANAGER_GET_ACCOUNT_REVIEW_FAILURE =
  "MANAGER_GET_ACCOUNT_REVIEW_FAILURE";

export const PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_REQUEST =
  "PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_REQUEST";
export const PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_SUCCESS =
  "PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_SUCCESS";
export const PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_FAILURE =
  "PETTY_CASHIER_REMOVE_ACCOUNT_REVIEW_FAILURE";

export const MANAGER_REMOVE_ACCOUNT_REVIEW_REQUEST =
  "MANAGER_REMOVE_ACCOUNT_REVIEW_REQUEST";
export const MANAGER_REMOVE_ACCOUNT_REVIEW_SUCCESS =
  "MANAGER_REMOVE_ACCOUNT_REVIEW_SUCCESS";
export const MANAGER_REMOVE_ACCOUNT_REVIEW_FAILURE =
  "MANAGER_REMOVE_ACCOUNT_REVIEW_FAILURE";

export const PETTY_CASHIER_GET_MONTHLY_REVIEW_REQUEST =
  "PETTY_CASHIER_GET_MONTHLY_REVIEW_REQUEST";
export const PETTY_CASHIER_GET_MONTHLY_REVIEW_SUCCESS =
  "PETTY_CASHIER_GET_MONTHLY_REVIEW_SUCCESS";
export const PETTY_CASHIER_GET_MONTHLY_REVIEW_FAILURE =
  "PETTY_CASHIER_GET_MONTHLY_REVIEW_FAILURE";

export const PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_REQUEST =
  "PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_REQUEST";
export const PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_SUCCESS =
  "PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_SUCCESS";
export const PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_FAILURE =
  "PETTY_CASHIER_GET_DETAIL_MONTHLY_REVIEW_FAILURE";

export const PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_REQUEST =
  "PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_REQUEST";
export const PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_SUCCESS =
  "PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_SUCCESS";
export const PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_FAILURE =
  "PETTY_CASHIER_SHOW_MONTHLY_REVIEW_BY_ACCOUNT_TITLES_FAILURE";

export const PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_REQUEST =
  "PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_REQUEST";
export const PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_SUCCESS =
  "PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_SUCCESS";
export const PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_FAILURE =
  "PETTY_CASHIER_REMOVE_MONTHLY_DETAIL_REVIEW_FAILURE";

export const PETTY_CASHIER_STORE_PAYMENT_REQUEST =
  "PETTY_CASHIER_STORE_PAYMENT_REQUEST";
export const PETTY_CASHIER_STORE_PAYMENT_SUCCESS =
  "PETTY_CASHIER_STORE_PAYMENT_SUCCESS";
export const PETTY_CASHIER_STORE_PAYMENT_FAILURE =
  "PETTY_CASHIER_STORE_PAYMENT_FAILURE";
export const PETTY_CASHIER_UPDATE_PAYMENT_REQUEST =
  "PETTY_CASHIER_UPDATE_PAYMENT_REQUEST";
export const PETTY_CASHIER_UPDATE_PAYMENT_SUCCESS =
  "PETTY_CASHIER_UPDATE_PAYMENT_SUCCESS";
export const PETTY_CASHIER_UPDATE_PAYMENT_FAILURE =
  "PETTY_CASHIER_UPDATE_PAYMENT_FAILURE";
export const PETTY_CASHIER_GET_PAYMENT_REQUEST =
  "PETTY_CASHIER_GET_PAYMENT_REQUEST";
export const PETTY_CASHIER_GET_PAYMENT_SUCCESS =
  "PETTY_CASHIER_GET_PAYMENT_SUCCESS";
export const PETTY_CASHIER_GET_PAYMENT_FAILURE =
  "PETTY_CASHIER_GET_PAYMENT_FAILURE";
export const PETTY_CASHIER_REMOVE_PAYMENT_REQUEST =
  "PETTY_CASHIER_REMOVE_PAYMENT_REQUEST";
export const PETTY_CASHIER_REMOVE_PAYMENT_SUCCESS =
  "PETTY_CASHIER_REMOVE_PAYMENT_SUCCESS";
export const PETTY_CASHIER_REMOVE_PAYMENT_FAILURE =
  "PETTY_CASHIER_REMOVE_PAYMENT_FAILURE";
export const PETTY_CASHIER_GET_IMAGE_PAYMENT_REQUEST =
  "PETTY_CASHIER_GET_IMAGE_PAYMENT_REQUEST";
export const PETTY_CASHIER_GET_IMAGE_PAYMENT_SUCCESS =
  "PETTY_CASHIER_GET_IMAGE_PAYMENT_SUCCESS";
export const PETTY_CASHIER_GET_IMAGE_PAYMENT_FAILURE =
  "PETTY_CASHIER_GET_IMAGE_PAYMENT_FAILURE";

export const MANAGER_STORE_PAYMENT_REQUEST = "MANAGER_STORE_PAYMENT_REQUEST";
export const MANAGER_STORE_PAYMENT_SUCCESS = "MANAGER_STORE_PAYMENT_SUCCESS";
export const MANAGER_STORE_PAYMENT_FAILURE = "MANAGER_STORE_PAYMENT_FAILURE";
export const MANAGER_UPDATE_PAYMENT_REQUEST = "MANAGER_UPDATE_PAYMENT_REQUEST";
export const MANAGER_UPDATE_PAYMENT_SUCCESS = "MANAGER_UPDATE_PAYMENT_SUCCESS";
export const MANAGER_UPDATE_PAYMENT_FAILURE = "MANAGER_UPDATE_PAYMENT_FAILURE";
export const MANAGER_GET_PAYMENT_REQUEST = "MANAGER_GET_PAYMENT_REQUEST";
export const MANAGER_GET_PAYMENT_SUCCESS = "MANAGER_GET_PAYMENT_SUCCESS";
export const MANAGER_GET_PAYMENT_FAILURE = "MANAGER_GET_PAYMENT_FAILURE";
export const MANAGER_REMOVE_PAYMENT_REQUEST = "MANAGER_REMOVE_PAYMENT_REQUEST";
export const MANAGER_REMOVE_PAYMENT_SUCCESS = "MANAGER_REMOVE_PAYMENT_SUCCESS";
export const MANAGER_REMOVE_PAYMENT_FAILURE = "MANAGER_REMOVE_PAYMENT_FAILURE";

export const MANAGER_GET_IMAGE_PAYMENT_REQUEST =
  "MANAGER_GET_IMAGE_PAYMENT_REQUEST";
export const MANAGER_GET_IMAGE_PAYMENT_SUCCESS =
  "MANAGER_GET_IMAGE_PAYMENT_SUCCESS";
export const MANAGER_GET_IMAGE_PAYMENT_FAILURE =
  "MANAGER_GET_IMAGE_PAYMENT_FAILURE";

export const PETTY_CASHIER_REMOVE_RECEIVE_REQUEST =
  "PETTY_CASHIER_REMOVE_RECEIVE_REQUEST";
export const PETTY_CASHIER_REMOVE_RECEIVE_SUCCESS =
  "PETTY_CASHIER_REMOVE_RECEIVE_SUCCESS";
export const PETTY_CASHIER_REMOVE_RECEIVE_FAILURE =
  "PETTY_CASHIER_REMOVE_RECEIVE_FAILURE";
export const PETTY_CASHIER_GET_IMAGE_RECEIVE_REQUEST =
  "PETTY_CASHIER_GET_IMAGE_RECEIVE_REQUEST";
export const PETTY_CASHIER_GET_IMAGE_RECEIVE_SUCCESS =
  "PETTY_CASHIER_GET_IMAGE_RECEIVE_SUCCESS";
export const PETTY_CASHIER_GET_IMAGE_RECEIVE_FAILURE =
  "PETTY_CASHIER_GET_IMAGE_RECEIVE_FAILURE";
export const PETTY_CASHIER_STORE_RECEIVE_REQUEST =
  "PETTY_CASHIER_STORE_RECEIVE_REQUEST";
export const PETTY_CASHIER_STORE_RECEIVE_SUCCESS =
  "PETTY_CASHIER_STORE_RECEIVE_SUCCESS";
export const PETTY_CASHIER_STORE_RECEIVE_FAILURE =
  "PETTY_CASHIER_STORE_RECEIVE_FAILURE";
export const PETTY_CASHIER_UPDATE_RECEIVE_REQUEST =
  "PETTY_CASHIER_UPDATE_RECEIVE_REQUEST";
export const PETTY_CASHIER_UPDATE_RECEIVE_SUCCESS =
  "PETTY_CASHIER_UPDATE_RECEIVE_SUCCESS";
export const PETTY_CASHIER_UPDATE_RECEIVE_FAILURE =
  "PETTY_CASHIER_UPDATE_RECEIVE_FAILURE";
export const PETTY_CASHIER_GET_RECEIVE_REQUEST =
  "PETTY_CASHIER_GET_RECEIVE_REQUEST";
export const PETTY_CASHIER_GET_RECEIVE_SUCCESS =
  "PETTY_CASHIER_GET_RECEIVE_SUCCESS";
export const PETTY_CASHIER_GET_RECEIVE_FAILURE =
  "PETTY_CASHIER_GET_RECEIVE_FAILURE";

export const MANAGER_REMOVE_RECEIVE_REQUEST = "MANAGER_REMOVE_RECEIVE_REQUEST";
export const MANAGER_REMOVE_RECEIVE_SUCCESS = "MANAGER_REMOVE_RECEIVE_SUCCESS";
export const MANAGER_REMOVE_RECEIVE_FAILURE = "MANAGER_REMOVE_RECEIVE_FAILURE";

export const MANAGER_GET_IMAGE_RECEIVE_REQUEST =
  "MANAGER_GET_IMAGE_RECEIVE_REQUEST";
export const MANAGER_GET_IMAGE_RECEIVE_SUCCESS =
  "MANAGER_GET_IMAGE_RECEIVE_SUCCESS";
export const MANAGER_GET_IMAGE_RECEIVE_FAILURE =
  "MANAGER_GET_IMAGE_RECEIVE_FAILURE";

export const MANAGER_STORE_RECEIVE_REQUEST = "MANAGER_STORE_RECEIVE_REQUEST";
export const MANAGER_STORE_RECEIVE_SUCCESS = "MANAGER_STORE_RECEIVE_SUCCESS";
export const MANAGER_STORE_RECEIVE_FAILURE = "MANAGER_STORE_RECEIVE_FAILURE";
export const MANAGER_UPDATE_RECEIVE_REQUEST = "MANAGER_UPDATE_RECEIVE_REQUEST";
export const MANAGER_UPDATE_RECEIVE_SUCCESS = "MANAGER_UPDATE_RECEIVE_SUCCESS";
export const MANAGER_UPDATE_RECEIVE_FAILURE = "MANAGER_UPDATE_RECEIVE_FAILURE";
export const MANAGER_GET_RECEIVE_REQUEST = "MANAGER_GET_RECEIVE_REQUEST";
export const MANAGER_GET_RECEIVE_SUCCESS = "MANAGER_GET_RECEIVE_SUCCESS";
export const MANAGER_GET_RECEIVE_FAILURE = "MANAGER_GET_RECEIVE_FAILURE";

export const SELECT_ITEM_FROM_AUTOCOMPLETE_COMPONENT =
  "SELECT_ITEM_FROM_AUTOCOMPLETE_COMPONENT";

export const SAVE_PREVIOUS_INFO_FOR_USE_AUTOCOMPLETE =
  "SAVE_PREVIOUS_INFO_FOR_USE_AUTOCOMPLETE";

export const SET_CONFIRM_DATA_FOR_ACTION_ON_TRANSACTION_REPORT =
  "SET_CONFIRM_DATA_FOR_ACTION_ON_TRANSACTION_REPORT";

export const CLOSE_CONFIRM_FOR_ACTION_ON_TRANSACTION_REPORT =
  "CLOSE_CONFIRM_FOR_ACTION_ON_TRANSACTION_REPORT";

export const TOGGLE_SELECT_MODE_FOR_FOR_REPORT =
  "TOGGLE_SELECT_MODE_FOR_FOR_REPORT";

export const EVENT_LIST_REQUEST = "EVENT_LIST_REQUEST";
export const EVENT_LIST_SUCCESS = "EVENT_LIST_SUCCESS";
export const EVENT_LIST_FAILURE = "EVENT_LIST_FAILURE";

export const PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_REQUEST =
  "PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_REQUEST";
export const PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_SUCCESS =
  "PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_SUCCESS";
export const PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_FAILURE =
  "PETTY_CASHIER_DASHBOARD_GET_2_NUMBERS_FAILURE";

export const PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_REQUEST =
  "PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_REQUEST";
export const PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_SUCCESS =
  "PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_SUCCESS";
export const PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_FAILURE =
  "PETTY_CASHIER_DASHBOARD_GET_CASH_REMAIN_FAILURE";

export const PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_REQUEST =
  "PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_REQUEST";
export const PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_SUCCESS =
  "PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_SUCCESS";
export const PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_FAILURE =
  "PETTY_CASHIER_DASHBOARD_GET_CLASSIFICATION_FAILURE";

export const PETTY_CASHIER_DASHBOARD_GET_PAYMENT_REQUEST =
  "PETTY_CASHIER_DASHBOARD_GET_PAYMENT_REQUEST";
export const PETTY_CASHIER_DASHBOARD_GET_PAYMENT_SUCCESS =
  "PETTY_CASHIER_DASHBOARD_GET_PAYMENT_SUCCESS";
export const PETTY_CASHIER_DASHBOARD_GET_PAYMENT_FAILURE =
  "PETTY_CASHIER_DASHBOARD_GET_PAYMENT_FAILURE";

export const MANAGER_DASHBOARD_GET_CLASSIFICATION_REQUEST =
  "MANAGER_DASHBOARD_GET_CLASSIFICATION_REQUEST";
export const MANAGER_DASHBOARD_GET_CLASSIFICATION_SUCCESS =
  "MANAGER_DASHBOARD_GET_CLASSIFICATION_SUCCESS";
export const MANAGER_DASHBOARD_GET_CLASSIFICATION_FAILURE =
  "MANAGER_DASHBOARD_GET_CLASSIFICATION_FAILURE";

export const MANAGER_DASHBOARD_GET_SUMMARY_REQUEST =
  "MANAGER_DASHBOARD_GET_SUMMARY_REQUEST";
export const MANAGER_DASHBOARD_GET_SUMMARY_SUCCESS =
  "MANAGER_DASHBOARD_GET_SUMMARY_SUCCESS";
export const MANAGER_DASHBOARD_GET_SUMMARY_FAILURE =
  "MANAGER_DASHBOARD_GET_SUMMARY_FAILURE";

export const PETTY_CASHIER_GET_OVERALL_COST_REQUEST =
  "PETTY_CASHIER_GET_OVERALL_COST_REQUEST";
export const PETTY_CASHIER_GET_OVERALL_COST_SUCCESS =
  "PETTY_CASHIER_GET_OVERALL_COST_SUCCESS";
export const PETTY_CASHIER_GET_OVERALL_COST_FAILURE =
  "PETTY_CASHIER_GET_OVERALL_COST_FAILURE";

export const MANAGER_GET_OVERALL_COST_REQUEST =
  "MANAGER_GET_OVERALL_COST_REQUEST";
export const MANAGER_GET_OVERALL_COST_SUCCESS =
  "MANAGER_GET_OVERALL_COST_SUCCESS";
export const MANAGER_GET_OVERALL_COST_FAILURE =
  "MANAGER_GET_OVERALL_COST_FAILURE";

export const PETTY_CASHIER_GET_OVERALL_COST_DETAIL_REQUEST =
  "PETTY_CASHIER_GET_OVERALL_COST_DETAIL_REQUEST";
export const PETTY_CASHIER_GET_OVERALL_COST_DETAIL_SUCCESS =
  "PETTY_CASHIER_GET_OVERALL_COST_DETAIL_SUCCESS";
export const PETTY_CASHIER_GET_OVERALL_COST_DETAIL_FAILURE =
  "PETTY_CASHIER_GET_OVERALL_COST_DETAIL_FAILURE";

export const PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_REQUEST =
  "PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_REQUEST";
export const PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_SUCCESS =
  "PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_SUCCESS";
export const PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_FAILURE =
  "PETTY_CASHIER_REMOVE_OVERALL_COST_DETAIL_FAILURE";

export const MANAGER_GET_OVERALL_COST_DETAIL_REQUEST =
  "MANAGER_GET_OVERALL_COST_DETAIL_REQUEST";
export const MANAGER_GET_OVERALL_COST_DETAIL_SUCCESS =
  "MANAGER_GET_OVERALL_COST_DETAIL_SUCCESS";
export const MANAGER_GET_OVERALL_COST_DETAIL_FAILURE =
  "MANAGER_GET_OVERALL_COST_DETAIL_FAILURE";

export const MANAGER_REMOVE_OVERALL_COST_DETAIL_REQUEST =
  "MANAGER_REMOVE_OVERALL_COST_DETAIL_REQUEST";
export const MANAGER_REMOVE_OVERALL_COST_DETAIL_SUCCESS =
  "MANAGER_REMOVE_OVERALL_COST_DETAIL_SUCCESS";
export const MANAGER_REMOVE_OVERALL_COST_DETAIL_FAILURE =
  "MANAGER_REMOVE_OVERALL_COST_DETAIL_FAILURE";

export const INVITATION_ACCEPT_REQUEST = "INVITATION_ACCEPT_REQUEST";
export const INVITATION_ACCEPT_SUCCESS = "INVITATION_ACCEPT_SUCCESS";
export const INVITATION_ACCEPT_FAILURE = "INVITATION_ACCEPT_FAILURE";

export const INVITATION_REJECT_REQUEST = "INVITATION_REJECT_REQUEST";
export const INVITATION_REJECT_SUCCESS = "INVITATION_REJECT_SUCCESS";
export const INVITATION_REJECT_FAILURE = "INVITATION_REJECT_FAILURE";

export const NOTIFICATION_READ_REQUEST = "NOTIFICATION_READ_REQUEST";

export const GET_PROJECT_SOFTWARE_SETTING_REQUEST =
  "GET_PROJECT_SOFTWARE_SETTING_REQUEST";
export const GET_PROJECT_SOFTWARE_SETTING_SUCCESS =
  "GET_PROJECT_SOFTWARE_SETTING_SUCCESS";
export const GET_PROJECT_SOFTWARE_SETTING_FAILURE =
  "GET_PROJECT_SOFTWARE_SETTING_FAILURE";

export const PROJECT_SOFTWARE_SETTING_STORE_REQUEST =
  "PROJECT_SOFTWARE_SETTING_STORE_REQUEST";
export const PROJECT_SOFTWARE_SETTING_STORE_SUCCESS =
  "PROJECT_SOFTWARE_SETTING_STORE_SUCCESS";
export const PROJECT_SOFTWARE_SETTING_STORE_FAILURE =
  "PROJECT_SOFTWARE_SETTING_STORE_FAILURE";

export const PROJECT_TRANSACTION_FORM_SETTING_STORE_REQUEST =
  "PROJECT_TRANSACTION_FORM_SETTING_STORE_REQUEST";
export const PROJECT_TRANSACTION_FORM_SETTING_STORE_SUCCESS =
  "PROJECT_TRANSACTION_FORM_SETTING_STORE_SUCCESS";
export const PROJECT_TRANSACTION_FORM_SETTING_STORE_FAILURE =
  "PROJECT_TRANSACTION_FORM_SETTING_STORE_FAILURE";

export const PROJECT_PAYMENT_VALIDATION_SETTING_STORE_REQUEST =
  "PROJECT_PAYMENT_VALIDATION_SETTING_STORE_REQUEST";
export const PROJECT_PAYMENT_VALIDATION_SETTING_STORE_SUCCESS =
  "PROJECT_PAYMENT_VALIDATION_SETTING_STORE_SUCCESS";
export const PROJECT_PAYMENT_VALIDATION_SETTING_STORE_FAILURE =
  "PROJECT_PAYMENT_VALIDATION_SETTING_STORE_FAILURE";

export const PROJECT_TRANSACTION_DATE_LIMIT_REQUEST =
  "PROJECT_TRANSACTION_DATE_LIMIT_REQUEST";
export const PROJECT_TRANSACTION_DATE_LIMIT_SUCCESS =
  "PROJECT_TRANSACTION_DATE_LIMIT_SUCCESS";
export const PROJECT_TRANSACTION_DATE_LIMIT_FAILURE =
  "PROJECT_TRANSACTION_FORM_SETTING_STORE_FAILURE";

export const PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_REQUEST =
  "PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_REQUEST";
export const PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_SUCCESS =
  "PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_SUCCESS";
export const PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_FAILURE =
  "PROJECT_SETTING_ACCOUNTING_SOFTWARE_LIST_FAILURE";

export const PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_REQUEST =
  "PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_REQUEST";
export const PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_SUCCESS =
  "PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_SUCCESS";
export const PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_FAILURE =
  "PROJECT_SETTING_SUB_ACCOUNTING_SOFTWARE_LIST_FAILURE";

export const PETTY_CASHIER_GET_PETTY_CASH_REQUEST =
  "PETTY_CASHIER_GET_PETTY_CASH_REQUEST";
export const PETTY_CASHIER_GET_PETTY_CASH_SUCCESS =
  "PETTY_CASHIER_GET_PETTY_CASH_SUCCESS";
export const PETTY_CASHIER_GET_PETTY_CASH_FAILURE =
  "PETTY_CASHIER_GET_PETTY_CASH_FAILURE";

export const PETTY_CASHIER_GET_PETTY_CASH_ITEMS_REQUEST =
  "PETTY_CASHIER_GET_PETTY_CASH_ITEMS_REQUEST";
export const PETTY_CASHIER_GET_PETTY_CASH_ITEMS_SUCCESS =
  "PETTY_CASHIER_GET_PETTY_CASH_ITEMS_SUCCESS";
export const PETTY_CASHIER_GET_PETTY_CASH_ITEMS_FAILURE =
  "PETTY_CASHIER_GET_PETTY_CASH_ITEMS_FAILURE";

export const MANAGER_GET_PETTY_CASH_REQUEST = "MANAGER_GET_PETTY_CASH_REQUEST";
export const MANAGER_GET_PETTY_CASH_SUCCESS = "MANAGER_GET_PETTY_CASH_SUCCESS";
export const MANAGER_GET_PETTY_CASH_FAILURE = "MANAGER_GET_PETTY_CASH_FAILURE";

export const MANAGER_GET_PETTY_CASH_ITEMS_REQUEST =
  "MANAGER_GET_PETTY_CASH_ITEMS_REQUEST";
export const MANAGER_GET_PETTY_CASH_ITEMS_SUCCESS =
  "MANAGER_GET_PETTY_CASH_ITEMS_SUCCESS";
export const MANAGER_GET_PETTY_CASH_ITEMS_FAILURE =
  "MANAGER_GET_PETTY_CASH_ITEMS_FAILURE";

export const PETTY_CASH_DETAIL_REQUEST = "PETTY_CASH_DETAIL_REQUEST";
export const PETTY_CASH_DETAIL_SUCCESS = "PETTY_CASH_DETAIL_SUCCESS";
export const PETTY_CASH_DETAIL_FAILURE = "PETTY_CASH_DETAIL_FAILURE";
export const PETTY_CASH_DETAIL_CLEAR = "PETTY_CASH_DETAIL_CLEAR";
export const PETTY_CASH_STORE_REQUEST = "PETTY_CASH_STORE_REQUEST";
export const PETTY_CASH_STORE_SUCCESS = "PETTY_CASH_STORE_SUCCESS";
export const PETTY_CASH_STORE_FAILURE = "PETTY_CASH_STORE_FAILURE";

export const PETTY_CASH_UPDATE_REQUEST = "PETTY_CASH_UPDATE_REQUEST";
export const PETTY_CASH_UPDATE_SUCCESS = "PETTY_CASH_UPDATE_SUCCESS";
export const PETTY_CASH_UPDATE_FAILURE = "PETTY_CASH_UPDATE_FAILURE";

export const PETTY_CASH_PRINT_INFO_MODAL_DATA =
  "PETTY_CASH_PRINT_INFO_MODAL_DATA";
export const PETTY_CASH_PRINT_INFO_CLOSE_MODAL =
  "PETTY_CASH_PRINT_INFO_CLOSE_MODAL";
export const PETTY_CASH_UPDATE_INFO_REQUEST = "PETTY_CASH_UPDATE_INFO_REQUEST";
export const PETTY_CASH_UPDATE_INFO_SUCCESS = "PETTY_CASH_UPDATE_INFO_SUCCESS";
export const PETTY_CASH_UPDATE_INFO_FAILURE = "PETTY_CASH_UPDATE_INFO_FAILURE";

export const PETTY_CASHIER_GET_LIST_PETTY_CASH_REQUEST =
  "PETTY_CASHIER_GET_LIST_PETTY_CASH_REQUEST";
export const PETTY_CASHIER_GET_LIST_PETTY_CASH_SUCCESS =
  "PETTY_CASHIER_GET_LIST_PETTY_CASH_SUCCESS";
export const PETTY_CASHIER_GET_LIST_PETTY_CASH_FAILURE =
  "PETTY_CASHIER_GET_LIST_PETTY_CASH_FAILURE";

export const MANAGER_GET_LIST_PETTY_CASH_REQUEST =
  "MANAGER_GET_LIST_PETTY_CASH_REQUEST";
export const MANAGER_GET_LIST_PETTY_CASH_SUCCESS =
  "MANAGER_GET_LIST_PETTY_CASH_SUCCESS";
export const MANAGER_GET_LIST_PETTY_CASH_FAILURE =
  "MANAGER_GET_LIST_PETTY_CASH_FAILURE";

export const MANAGER_GET_TRASHED_SEQUENCE_REQUEST =
  "MANAGER_GET_TRASHED_SEQUENCE_REQUEST";
export const MANAGER_GET_TRASHED_SEQUENCE_SUCCESS =
  "MANAGER_GET_TRASHED_SEQUENCE_SUCCESS";
export const MANAGER_GET_TRASHED_SEQUENCE_FAILURE =
  "MANAGER_GET_TRASHED_SEQUENCE_FAILURE";

export const MANAGER_GET_NUMBER_LIST_PETTY_CASH_REQUEST =
  "MANAGER_GET_NUMBER_LIST_PETTY_CASH_REQUEST";
export const MANAGER_GET_NUMBER_LIST_PETTY_CASH_SUCCESS =
  "MANAGER_GET_NUMBER_LIST_PETTY_CASH_SUCCESS";
export const MANAGER_GET_NUMBER_LIST_PETTY_CASH_FAILURE =
  "MANAGER_GET_NUMBER_LIST_PETTY_CASH_FAILURE";

export const PETTY_CASH_SELECT_ARCHIVE_UPDATE =
  "PETTY_CASH_SELECT_ARCHIVE_UPDATE";
export const PETTY_CASH_SAVE_LAST_INFO = "PETTY_CASH_SAVE_LAST_INFO";

export const PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_REQUEST =
  "PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_REQUEST";
export const PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_SUCCESS =
  "PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_SUCCESS";
export const PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_FAILURE =
  "PETTY_CASHIER_CHANGE_STATE_PETTY_CASH_FAILURE";

export const MANAGER_CHANGE_STATE_PETTY_CASH_REQUEST =
  "MANAGER_CHANGE_STATE_PETTY_CASH_REQUEST";
export const MANAGER_CHANGE_STATE_PETTY_CASH_SUCCESS =
  "MANAGER_CHANGE_STATE_PETTY_CASH_SUCCESS";
export const MANAGER_CHANGE_STATE_PETTY_CASH_FAILURE =
  "MANAGER_CHANGE_STATE_PETTY_CASH_FAILURE";

export const UNDER_MANAGER_CONTROL_USERS_LIST_REQUEST =
  "UNDER_MANAGER_CONTROL_USERS_LIST_REQUEST";
export const UNDER_MANAGER_CONTROL_USERS_LIST_SUCCESS =
  "UNDER_MANAGER_CONTROL_USERS_LIST_SUCCESS";
export const UNDER_MANAGER_CONTROL_USERS_LIST_FAILURE =
  "UNDER_MANAGER_CONTROL_USERS_LIST_FAILURE";

export const REMOVE_PETTY_CASH_REQUEST = "REMOVE_PETTY_CASH_REQUEST";
export const REMOVE_PETTY_CASH_SUCCESS = "REMOVE_PETTY_CASH_SUCCESS";
export const REMOVE_PETTY_CASH_FAILURE = "REMOVE_PETTY_CASH_FAILURE";

export const PETTY_CASH_DETAIL_FILTER_REQUEST =
  "PETTY_CASH_DETAIL_FILTER_REQUEST";
export const PETTY_CASH_DETAIL_FILTER_SUCCESS =
  "PETTY_CASH_DETAIL_FILTER_SUCCESS";
export const PETTY_CASH_DETAIL_FILTER_FAILURE =
  "PETTY_CASH_DETAIL_FILTER_FAILURE";
export const PETTY_CASH_EMPTY_DETAIL_FILTER = "PETTY_CASH_EMPTY_DETAIL_FILTER";

export const SET_REASON_PAGE_MODAL_DATA = "SET_REASON_PAGE_MODAL_DATA";
export const CLOSE_REASON_PAGE_MODAL_DATA = "CLOSE_REASON_PAGE_MODAL_DATA";

export const SET_PETTY_CASH_CONFIRM_DATA = "SET_PETTY_CASH_CONFIRM_DATA";
export const CLOSE_PETTY_CASH_CONFIRM_DATA = "CLOSE_PETTY_CASH_CONFIRM_DATA";

export const GET_FILES_REQUEST = "GET_FILES_REQUEST";
export const GET_FILES_SUCCESS = "GET_FILES_SUCCESS";
export const GET_FILES_FAILURE = "GET_FILES_FAILURE";

export const REMOVE_FILE_REQUEST = "REMOVE_FILE_REQUEST";
export const REMOVE_FILE_SUCCESS = "REMOVE_FILE_SUCCESS";
export const REMOVE_FILE_FAILURE = "REMOVE_FILE_FAILURE";

export const DOWNLOAD_FILE_MODAL_DATA = "DOWNLOAD_FILE_MODAL_DATA";
export const DOWNLOAD_FILE_CLOSE_MODAL = "DOWNLOAD_FILE_CLOSE_MODAL";
export const DOWNLOAD_FILE_REPORT_REQUEST = "DOWNLOAD_FILE_REPORT_REQUEST";
export const DOWNLOAD_FILE_REPORT_SUCCESS = "DOWNLOAD_FILE_REPORT_SUCCESS";
export const DOWNLOAD_FILE_REPORT_FAILURE = "DOWNLOAD_FILE_REPORT_FAILURE";
export const DOWNLOAD_FILE_COUNT_TOAST_TOGGLE =
  "DOWNLOAD_FILE_COUNT_TOAST_TOGGLE";
export const DOWNLOAD_FILE_CHECK_FILES_REQUEST =
  "DOWNLOAD_FILE_CHECK_FILES_REQUEST";
export const DOWNLOAD_FILE_CHECK_FILES_SUCCESS =
  "DOWNLOAD_FILE_CHECK_FILES_SUCCESS";
export const DOWNLOAD_FILE_CHECK_FILES_FAILURE =
  "DOWNLOAD_FILE_CHECK_FILES_FAILURE";
export const DOWNLOAD_FILE_TOASTED = "DOWNLOAD_FILE_TOASTED";

export const ANNOUNCEMENT_SHOW_REQUEST = "ANNOUNCEMENT_SHOW_REQUEST";
export const ANNOUNCEMENT_SHOW_SUCCESS = "ANNOUNCEMENT_SHOW_SUCCESS";
export const ANNOUNCEMENT_SHOW_FAILURE = "ANNOUNCEMENT_SHOW_FAILURE";
export const ANNOUNCEMENT_READ_REQUEST = "ANNOUNCEMENT_READ_REQUEST";

export const TICKET_LIST_REQUEST = "TICKET_LIST_REQUEST";
export const TICKET_LIST_SUCCESS = "TICKET_LIST_SUCCESS";
export const TICKET_LIST_FAILURE = "TICKET_LIST_FAILURE";

export const TICKET_STORE_REQUEST = "TICKET_STORE_REQUEST";
export const TICKET_STORE_SUCCESS = "TICKET_STORE_SUCCESS";
export const TICKET_STORE_FAILURE = "TICKET_STORE_FAILURE";

export const TICKET_SHOW_REQUEST = "TICKET_SHOW_REQUEST";
export const TICKET_SHOW_SUCCESS = "TICKET_SHOW_SUCCESS";
export const TICKET_SHOW_FAILURE = "TICKET_SHOW_FAILURE";

export const TICKET_UPDATE_REQUEST = "TICKET_UPDATE_REQUEST";
export const TICKET_UPDATE_SUCCESS = "TICKET_UPDATE_SUCCESS";
export const TICKET_UPDATE_FAILURE = "TICKET_UPDATE_FAILURE";

export const TICKET_MODAL_DATA = "TICKET_MODAL_DATA";
export const TICKET_CLOSE_MODAL = "TICKET_CLOSE_MODAL";

export const GET_USER_INFO_REQUEST = "GET_USER_INFO_REQUEST";
export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS";
export const GET_USER_INFO_FAILURE = "GET_USER_INFO_FAILURE";

export const UPDATE_USER_INFO_REQUEST = "UPDATE_USER_INFO_REQUEST";
export const UPDATE_USER_INFO_SUCCESS = "UPDATE_USER_INFO_SUCCESS";
export const UPDATE_USER_INFO_FAILURE = "UPDATE_USER_INFO_FAILURE";

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

export const CHECK_PHONE_NUMBER_REQUEST = "CHECK_PHONE_NUMBER_REQUEST";
export const CHECK_PHONE_NUMBER_SUCCESS = "CHECK_PHONE_NUMBER_SUCCESS";
export const CHECK_PHONE_NUMBER_FAILURE = "CHECK_PHONE_NUMBER_FAILURE";

export const SEND_SMS_REQUEST = "SEND_SMS_REQUEST";
export const SEND_SMS_SUCCESS = "SEND_SMS_SUCCESS";
export const SEND_SMS_FAILURE = "SEND_SMS_FAILURE";

export const INVITE_REQUEST = "INVITE_REQUEST";
export const INVITE_SUCCESS = "INVITE_SUCCESS";
export const INVITE_FAILURE = "INVITE_FAILURE";

export const SHARED_CONTACTS_REQUEST = "SHARED_CONTACTS_REQUEST";
export const SHARED_CONTACTS_SUCCESS = "SHARED_CONTACTS_SUCCESS";
export const SHARED_CONTACTS_FAILURE = "SHARED_CONTACTS_FAILURE";

export const SET_USER_STATE_REQUEST = "SET_USER_STATE_REQUEST";
export const SET_USER_STATE_SUCCESS = "SET_USER_STATE_SUCCESS";
export const SET_USER_STATE_FAILURE = "SET_USER_STATE_FAILURE";

export const SHOW_USER_REQUEST = "SHOW_USER_REQUEST";
export const SHOW_USER_SUCCESS = "SHOW_USER_SUCCESS";
export const SHOW_USER_FAILURE = "SHOW_USER_FAILURE";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const PREMIUM_INIT_REQUEST = "PREMIUM_INIT_REQUEST";
export const PREMIUM_INIT_SUCCESS = "PREMIUM_INIT_SUCCESS";
export const PREMIUM_INIT_FAILURE = "PREMIUM_INIT_FAILURE";

export const PREMIUM_TRANSACTION_LIST_REQUEST =
  "PREMIUM_TRANSACTION_LIST_REQUEST";
export const PREMIUM_TRANSACTION_LIST_SUCCESS =
  "PREMIUM_TRANSACTION_LIST_SUCCESS";
export const PREMIUM_TRANSACTION_LIST_FAILURE =
  "PREMIUM_TRANSACTION_LIST_FAILURE";

export const PREMIUM_TRANSACTION_LIST_BY_PROJECT_REQUEST =
  "PREMIUM_TRANSACTION_LIST_BY_PROJECT_REQUEST";
export const PREMIUM_TRANSACTION_LIST_BY_PROJECT_SUCCESS =
  "PREMIUM_TRANSACTION_LIST_BY_PROJECT_SUCCESS";
export const PREMIUM_TRANSACTION_LIST_BY_PROJECT_FAILURE =
  "PREMIUM_TRANSACTION_LIST_BY_PROJECT_FAILURE";

export const PREMIUM_CALCULATE_PRICE_REQUEST =
  "PREMIUM_CALCULATE_PRICE_REQUEST";
export const PREMIUM_CALCULATE_PRICE_SUCCESS =
  "PREMIUM_CALCULATE_PRICE_SUCCESS";
export const PREMIUM_CALCULATE_PRICE_FAILURE =
  "PREMIUM_CALCULATE_PRICE_FAILURE";

export const PREMIUM_BUY_GIFT_REQUEST = "PREMIUM_BUY_GIFT_REQUEST";
export const PREMIUM_BUY_GIFT_SUCCESS = "PREMIUM_BUY_GIFT_SUCCESS";
export const PREMIUM_BUY_GIFT_FAILURE = "PREMIUM_BUY_GIFT_FAILURE";

export const PREMIUM_USE_WALLET_REQUEST = "PREMIUM_USE_WALLET_REQUEST";
export const PREMIUM_USE_WALLET_SUCCESS = "PREMIUM_USE_WALLET_SUCCESS";
export const PREMIUM_USE_WALLET_FAILURE = "PREMIUM_USE_WALLET_FAILURE";

export const PREMIUM_USE_PROMO_CODE_REQUEST = "PREMIUM_USE_PROMO_CODE_REQUEST";
export const PREMIUM_USE_PROMO_CODE_SUCCESS = "PREMIUM_USE_PROMO_CODE_SUCCESS";
export const PREMIUM_USE_PROMO_CODE_FAILURE = "PREMIUM_USE_PROMO_CODE_FAILURE";

export const PREMIUM_INFO_SAVE_IN_CASH = "PREMIUM_INFO_SAVE_IN_CASH";

export const WARN_OWNER_REQUEST = "WARN_OWNER_REQUEST";

export const PREMIUM_PAY_REQUEST = "PREMIUM_PAY_REQUEST";
export const PREMIUM_PAY_SUCCESS = "PREMIUM_PAY_SUCCESS";
export const PREMIUM_PAY_FAILURE = "PREMIUM_PAY_FAILURE";

export const PREMIUM_PROMO_CODE_REQUEST = "PREMIUM_PROMO_CODE_REQUEST";
export const PREMIUM_PROMO_CODE_SUCCESS = "PREMIUM_PROMO_CODE_SUCCESS";
export const PREMIUM_PROMO_CODE_FAILURE = "PREMIUM_PROMO_CODE_FAILURE";

export const PREMIUM_ACTIVE_PLANS_REQUEST = "PREMIUM_ACTIVE_PLANS_REQUEST";
export const PREMIUM_ACTIVE_PLANS_SUCCESS = "PREMIUM_ACTIVE_PLANS_SUCCESS";
export const PREMIUM_ACTIVE_PLANS_FAILURE = "PREMIUM_ACTIVE_PLANS_FAILURE";

export const INVITE_TO_APP_REQUEST = "INVITE_TO_APP_REQUEST";
export const INVITE_TO_APP_SUCCESS = "INVITE_TO_APP_SUCCESS";
export const INVITE_TO_APP_FAILURE = "INVITE_TO_APP_FAILURE";

export const PREMIUM_TRANSACTION_ITEM_REQUEST =
  "PREMIUM_TRANSACTION_ITEM_REQUEST";
export const PREMIUM_TRANSACTION_ITEM_SUCCESS =
  "PREMIUM_TRANSACTION_ITEM_SUCCESS";
export const PREMIUM_TRANSACTION_ITEM_FAILURE =
  "PREMIUM_TRANSACTION_ITEM_FAILURE";

export const GET_COUNTRY_CODE_REQUEST = "GET_COUNTRY_CODE_REQUEST";
export const GET_COUNTRY_CODE_SUCCESS = "GET_COUNTRY_CODE_SUCCESS";
export const GET_COUNTRY_CODE_FAILURE = "GET_COUNTRY_CODE_FAILURE";

export const GET_CURRENCIES_REQUEST = "GET_CURRENCIES_REQUEST";
export const GET_CURRENCIES_SUCCESS = "GET_CURRENCIES_SUCCESS";
export const GET_CURRENCIES_FAILURE = "GET_CURRENCIES_FAILURE";

export const GET_ACCOUNT_TITLE_REQUEST = "GET_ACCOUNT_TITLE_REQUEST";
export const GET_ACCOUNT_TITLE_SUCCESS = "GET_ACCOUNT_TITLE_SUCCESS";
export const GET_ACCOUNT_TITLE_FAILURE = "GET_ACCOUNT_TITLE_FAILURE";

export const SHOW_ACCOUNT_TITLE_REQUEST = "SHOW_ACCOUNT_TITLE_REQUEST";
export const SHOW_ACCOUNT_TITLE_SUCCESS = "SHOW_ACCOUNT_TITLE_SUCCESS";
export const SHOW_ACCOUNT_TITLE_FAILURE = "SHOW_ACCOUNT_TITLE_FAILURE";

export const REMOVE_ACCOUNT_TITLE_REQUEST = "REMOVE_ACCOUNT_TITLE_REQUEST";
export const REMOVE_ACCOUNT_TITLE_SUCCESS = "REMOVE_ACCOUNT_TITLE_SUCCESS";
export const REMOVE_ACCOUNT_TITLE_FAILURE = "REMOVE_ACCOUNT_TITLE_FAILURE";

export const STORE_ACCOUNT_TITLE_REQUEST = "STORE_ACCOUNT_TITLE_REQUEST";
export const STORE_ACCOUNT_TITLE_SUCCESS = "STORE_ACCOUNT_TITLE_SUCCESS";
export const STORE_ACCOUNT_TITLE_FAILURE = "STORE_ACCOUNT_TITLE_FAILURE";

export const GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_REQUEST =
  "GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_REQUEST";
export const GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_SUCCESS =
  "GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_SUCCESS";
export const GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_FAILURE =
  "GET_TYPES_FOR_GET_DEFAULTS_ACCOUNT_TITLE_FAILURE";

export const GET_DEFAULTS_ACCOUNT_TITLE_REQUEST =
  "GET_DEFAULTS_ACCOUNT_TITLE_REQUEST";
export const GET_DEFAULTS_ACCOUNT_TITLE_SUCCESS =
  "GET_DEFAULTS_ACCOUNT_TITLE_SUCCESS";
export const GET_DEFAULTS_ACCOUNT_TITLE_FAILURE =
  "GET_DEFAULTS_ACCOUNT_TITLE_FAILURE";

export const TOGGLE_DEFAULT_ACCOUNT_TITLE_LIST_MODAL =
  "TOGGLE_DEFAULT_ACCOUNT_TITLE_LIST_MODAL";
export const TOGGLE_IMPORT_EXCEL_TEAM_MODAL = "TOGGLE_IMPORT_EXCEL_TEAM_MODAL";

export const STORE_DEFAULT_ACCOUNT_TITLE_REQUEST =
  "STORE_DEFAULT_ACCOUNT_TITLE_REQUEST";
export const STORE_DEFAULT_ACCOUNT_TITLE_SUCCESS =
  "STORE_DEFAULT_ACCOUNT_TITLE_SUCCESS";
export const STORE_DEFAULT_ACCOUNT_TITLE_FAILURE =
  "STORE_DEFAULT_ACCOUNT_TITLE_FAILURE";

export const UPDATE_ACCOUNT_TITLE_REQUEST = "UPDATE_ACCOUNT_TITLE_REQUEST";
export const UPDATE_ACCOUNT_TITLE_SUCCESS = "UPDATE_ACCOUNT_TITLE_SUCCESS";
export const UPDATE_ACCOUNT_TITLE_FAILURE = "UPDATE_ACCOUNT_TITLE_FAILURE";

export const IMPORT_FILE_ACCOUNT_TITLE_REQUEST =
  "IMPORT_FILE_ACCOUNT_TITLE_REQUEST";
export const IMPORT_FILE_ACCOUNT_TITLE_SUCCESS =
  "IMPORT_FILE_ACCOUNT_TITLE_SUCCESS";
export const IMPORT_FILE_ACCOUNT_TITLE_FAILURE =
  "IMPORT_FILE_ACCOUNT_TITLE_FAILURE";

export const CLEAR_ACCOUNT_TITLE_LIST = "CLEAR_ACCOUNT_TITLE_LIST";
export const EMPTY_LAST_ACCOUNT_TITLE_ITEM = "EMPTY_LAST_ACCOUNT_TITLE_ITEM";

export const GET_COST_CENTER_REQUEST = "GET_COST_CENTER_REQUEST";
export const GET_COST_CENTER_SUCCESS = "GET_COST_CENTER_SUCCESS";
export const GET_COST_CENTER_FAILURE = "GET_COST_CENTER_FAILURE";

export const SHOW_COST_CENTER_REQUEST = "SHOW_COST_CENTER_REQUEST";
export const SHOW_COST_CENTER_SUCCESS = "SHOW_COST_CENTER_SUCCESS";
export const SHOW_COST_CENTER_FAILURE = "SHOW_COST_CENTER_FAILURE";

export const REMOVE_COST_CENTER_REQUEST = "REMOVE_COST_CENTER_REQUEST";
export const REMOVE_COST_CENTER_SUCCESS = "REMOVE_COST_CENTER_SUCCESS";
export const REMOVE_COST_CENTER_FAILURE = "REMOVE_COST_CENTER_FAILURE";

export const STORE_COST_CENTER_REQUEST = "STORE_COST_CENTER_REQUEST";
export const STORE_COST_CENTER_SUCCESS = "STORE_COST_CENTER_SUCCESS";
export const STORE_COST_CENTER_FAILURE = "STORE_COST_CENTER_FAILURE";

export const UPDATE_COST_CENTER_REQUEST = "UPDATE_COST_CENTER_REQUEST";
export const UPDATE_COST_CENTER_SUCCESS = "UPDATE_COST_CENTER_SUCCESS";
export const UPDATE_COST_CENTER_FAILURE = "UPDATE_COST_CENTER_FAILURE";

export const CLEAR_COST_CENTER_LIST = "CLEAR_COST_CENTER_LIST";

export const GET_CONTACT_REQUEST = "GET_CONTACT_REQUEST";
export const GET_CONTACT_SUCCESS = "GET_CONTACT_SUCCESS";
export const GET_CONTACT_FAILURE = "GET_CONTACT_FAILURE";

export const SHOW_CONTACT_REQUEST = "SHOW_CONTACT_REQUEST";
export const SHOW_CONTACT_SUCCESS = "SHOW_CONTACT_SUCCESS";
export const SHOW_CONTACT_FAILURE = "SHOW_CONTACT_FAILURE";

export const REMOVE_CONTACT_REQUEST = "REMOVE_CONTACT_REQUEST";
export const REMOVE_CONTACT_SUCCESS = "REMOVE_CONTACT_SUCCESS";
export const REMOVE_CONTACT_FAILURE = "REMOVE_CONTACT_FAILURE";

export const STORE_CONTACT_REQUEST = "STORE_CONTACT_REQUEST";
export const STORE_CONTACT_SUCCESS = "STORE_CONTACT_SUCCESS";
export const STORE_CONTACT_FAILURE = "STORE_CONTACT_FAILURE";

export const UPDATE_CONTACT_REQUEST = "UPDATE_CONTACT_REQUEST";
export const UPDATE_CONTACT_SUCCESS = "UPDATE_CONTACT_SUCCESS";
export const UPDATE_CONTACT_FAILURE = "UPDATE_CONTACT_FAILURE";

export const CLEAR_CONTACT_LIST = "CLEAR_CONTACT_LIST";

export const SHOW_UPLOAD_IMAGE_MODAL = "SHOW_UPLOAD_IMAGE_MODAL";
export const HIDE_UPLOAD_IMAGE_MODAL = "HIDE_UPLOAD_IMAGE_MODAL";
export const UPLOAD_IMAGE_REQUEST = "UPLOAD_IMAGE_REQUEST";
export const UPLOAD_IMAGE_SUCCESS = "UPLOAD_IMAGE_SUCCESS";
export const UPLOAD_IMAGE_FAILURE = "UPLOAD_IMAGE_FAILURE";

export const GET_HASHTAG_REQUEST = "GET_HASHTAG_REQUEST";
export const GET_HASHTAG_SUCCESS = "GET_HASHTAG_SUCCESS";
export const GET_HASHTAG_FAILURE = "GET_HASHTAG_FAILURE";

export const SHOW_HASHTAG_REQUEST = "SHOW_HASHTAG_REQUEST";
export const SHOW_HASHTAG_SUCCESS = "SHOW_HASHTAG_SUCCESS";
export const SHOW_HASHTAG_FAILURE = "SHOW_HASHTAG_FAILURE";

export const REMOVE_HASHTAG_REQUEST = "REMOVE_HASHTAG_REQUEST";
export const REMOVE_HASHTAG_SUCCESS = "REMOVE_HASHTAG_SUCCESS";
export const REMOVE_HASHTAG_FAILURE = "REMOVE_HASHTAG_FAILURE";

export const STORE_HASHTAG_REQUEST = "STORE_HASHTAG_REQUEST";
export const STORE_HASHTAG_SUCCESS = "STORE_HASHTAG_SUCCESS";
export const STORE_HASHTAG_FAILURE = "STORE_HASHTAG_FAILURE";

export const UPDATE_HASHTAG_REQUEST = "UPDATE_HASHTAG_REQUEST";
export const UPDATE_HASHTAG_SUCCESS = "UPDATE_HASHTAG_SUCCESS";
export const UPDATE_HASHTAG_FAILURE = "UPDATE_HASHTAG_FAILURE";

export const CLEAR_HASHTAG_LIST = "CLEAR_HASHTAG_LIST";

export const PETTY_CASHIER_GET_HASHTAG_SUMMARY_REQUEST =
  "PETTY_CASHIER_GET_HASHTAG_SUMMARY_REQUEST";
export const PETTY_CASHIER_GET_HASHTAG_SUMMARY_SUCCESS =
  "PETTY_CASHIER_GET_HASHTAG_SUMMARY_SUCCESS";
export const PETTY_CASHIER_GET_HASHTAG_SUMMARY_FAILURE =
  "PETTY_CASHIER_GET_HASHTAG_SUMMARY_FAILURE";

export const PETTY_CASHIER_GET_ALL_HASHTAG_USED_REQUEST =
  "PETTY_CASHIER_GET_ALL_HASHTAG_USED_REQUEST";
export const PETTY_CASHIER_GET_ALL_HASHTAG_USED_SUCCESS =
  "PETTY_CASHIER_GET_ALL_HASHTAG_USED_SUCCESS";
export const PETTY_CASHIER_GET_ALL_HASHTAG_USED_FAILURE =
  "PETTY_CASHIER_GET_ALL_HASHTAG_USED_FAILURE";

export const PETTY_CASHIER_GET_HASHTAG_DETAIL_REVIEW_REQUEST =
  "PETTY_CASHIER_GET_HASHTAG_DETAIL_REVIEW_REQUEST";
export const PETTY_CASHIER_GET_HASHTAG_DETAIL_REVIEW_SUCCESS =
  "PETTY_CASHIER_GET_HASHTAG_DETAIL_REVIEW_SUCCESS";
export const PETTY_CASHIER_GET_HASHTAG_DETAIL_REVIEW_FAILURE =
  "PETTY_CASHIER_GET_HASHTAG_DETAIL_REVIEW_FAILURE";
export const PETTY_CASHIER_REMOVE_HASHTAG_DETAIL_REVIEW_REQUEST =
  "PETTY_CASHIER_REMOVE_HASHTAG_DETAIL_REVIEW_REQUEST";
export const PETTY_CASHIER_REMOVE_HASHTAG_DETAIL_REVIEW_SUCCESS =
  "PETTY_CASHIER_REMOVE_HASHTAG_DETAIL_REVIEW_SUCCESS";
export const PETTY_CASHIER_REMOVE_HASHTAG_DETAIL_REVIEW_FAILURE =
  "PETTY_CASHIER_REMOVE_HASHTAG_DETAIL_REVIEW_FAILURE";

export const MANAGER_GET_HASHTAG_SUMMARY_REQUEST =
  "MANAGER_GET_HASHTAG_SUMMARY_REQUEST";
export const MANAGER_GET_HASHTAG_SUMMARY_SUCCESS =
  "MANAGER_GET_HASHTAG_SUMMARY_SUCCESS";
export const MANAGER_GET_HASHTAG_SUMMARY_FAILURE =
  "MANAGER_GET_HASHTAG_SUMMARY_FAILURE";

export const MANAGER_GET_ALL_HASHTAG_USED_REQUEST =
  "MANAGER_GET_ALL_HASHTAG_USED_REQUEST";
export const MANAGER_GET_ALL_HASHTAG_USED_SUCCESS =
  "MANAGER_GET_ALL_HASHTAG_USED_SUCCESS";
export const MANAGER_GET_ALL_HASHTAG_USED_FAILURE =
  "MANAGER_GET_ALL_HASHTAG_USED_FAILURE";

export const MANAGER_GET_HASHTAG_DETAIL_REVIEW_REQUEST =
  "MANAGER_GET_HASHTAG_DETAIL_REVIEW_REQUEST";
export const MANAGER_GET_HASHTAG_DETAIL_REVIEW_SUCCESS =
  "MANAGER_GET_HASHTAG_DETAIL_REVIEW_SUCCESS";
export const MANAGER_GET_HASHTAG_DETAIL_REVIEW_FAILURE =
  "MANAGER_GET_HASHTAG_DETAIL_REVIEW_FAILURE";

export const PETTY_CASHIER_GET_CONTACT_SUMMARY_REQUEST =
  "PETTY_CASHIER_GET_CONTACT_SUMMARY_REQUEST";
export const PETTY_CASHIER_GET_CONTACT_SUMMARY_SUCCESS =
  "PETTY_CASHIER_GET_CONTACT_SUMMARY_SUCCESS";
export const PETTY_CASHIER_GET_CONTACT_SUMMARY_FAILURE =
  "PETTY_CASHIER_GET_CONTACT_SUMMARY_FAILURE";

export const PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_REQUEST =
  "PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_REQUEST";
export const PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_SUCCESS =
  "PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_SUCCESS";
export const PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_FAILURE =
  "PETTY_CASHIER_GET_CONTACT_DETAIL_REVIEW_FAILURE";

export const MANAGER_GET_CONTACT_SUMMARY_REQUEST =
  "MANAGER_GET_CONTACT_SUMMARY_REQUEST";
export const MANAGER_GET_CONTACT_SUMMARY_SUCCESS =
  "MANAGER_GET_CONTACT_SUMMARY_SUCCESS";
export const MANAGER_GET_CONTACT_SUMMARY_FAILURE =
  "MANAGER_GET_CONTACT_SUMMARY_FAILURE";

export const MANAGER_GET_CONTACT_DETAIL_REVIEW_REQUEST =
  "MANAGER_GET_CONTACT_DETAIL_REVIEW_REQUEST";
export const MANAGER_GET_CONTACT_DETAIL_REVIEW_SUCCESS =
  "MANAGER_GET_CONTACT_DETAIL_REVIEW_SUCCESS";
export const MANAGER_GET_CONTACT_DETAIL_REVIEW_FAILURE =
  "MANAGER_GET_CONTACT_DETAIL_REVIEW_FAILURE";

export const PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_REQUEST =
  "PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_REQUEST";
export const PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_SUCCESS =
  "PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_SUCCESS";
export const PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_FAILURE =
  "PETTY_CASHIER_REMOVE_CONTACT_DETAIL_REVIEW_FAILURE";

export const MAINTAIN_DATE_AND_TIME = "MAINTAIN_DATE_AND_TIME";
export const SAVE_INFO_FOR_CASH_PURPOSE = "SAVE_INFO_FOR_CASH_PURPOSE";
export const SET_CONFIRM_DATA_FOR_TABLE = "SET_CONFIRM_DATA_FOR_TABLE";
export const CLOSE_CONFIRM_FOR_TABLE = "CLOSE_CONFIRM_FOR_TABLE";
export const TOGGLE_SELECT_MODE_FOR_TABLE = "TOGGLE_SELECT_MODE_FOR_TABLE";
export const SET_MODAL_DATA_FOR_LONG_ERROR = "SET_MODAL_DATA_FOR_LONG_ERROR";
export const CLOSE_MODAL_FOR_LONG_ERROR = "CLOSE_MODAL_FOR_LONG_ERROR";

export const IMPORT_FILE_TRANSACTIONS_REQUEST =
  "IMPORT_FILE_TRANSACTIONS_REQUEST";
export const IMPORT_FILE_TRANSACTIONS_SUCCESS =
  "IMPORT_FILE_TRANSACTIONS_SUCCESS";
export const IMPORT_FILE_TRANSACTIONS_FAILURE =
  "IMPORT_FILE_TRANSACTIONS_FAILURE";

export const CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_REQUEST =
  "CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_REQUEST";
export const CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_SUCCESS =
  "CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_SUCCESS";
export const CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_FAILURE =
  "CREATE_MISSING_OBJECTS_FOR_IMPORT_TRANSACTIONS_FAILURE";

export const GET_ITEMS_OF_IMPORTED_TRANSACTIONS_REQUEST =
  "GET_ITEMS_OF_IMPORTED_TRANSACTIONS_REQUEST";
export const GET_ITEMS_OF_IMPORTED_TRANSACTIONS_SUCCESS =
  "GET_ITEMS_OF_IMPORTED_TRANSACTIONS_SUCCESS";
export const GET_ITEMS_OF_IMPORTED_TRANSACTIONS_FAILURE =
  "GET_ITEMS_OF_IMPORTED_TRANSACTIONS_FAILURE";

export const STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_REQUEST =
  "STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_REQUEST";
export const STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_SUCCESS =
  "STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_SUCCESS";
export const STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_FAILURE =
  "STORE_ITEMS_OF_IMPORTED_TRANSACTIONS_FAILURE";

export const MULTI_DELETE_TRANSACTIONS_REQUEST =
  "MULTI_DELETE_TRANSACTIONS_REQUEST";
export const MULTI_DELETE_TRANSACTIONS_SUCCESS =
  "MULTI_DELETE_TRANSACTIONS_SUCCESS";
export const MULTI_DELETE_TRANSACTIONS_FAILURE =
  "MULTI_DELETE_TRANSACTIONS_FAILURE";

export const PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_REQUEST =
  "PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_REQUEST";
export const PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_SUCCESS =
  "PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_SUCCESS";
export const PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_FAILURE =
  "PETTY_CASHIER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_FAILURE";

export const MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_REQUEST =
  "MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_REQUEST";
export const MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_SUCCESS =
  "MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_SUCCESS";
export const MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_FAILURE =
  "MANAGER_COPY_TRANSACTIONS_TO_OTHER_PROJECT_FAILURE";

export const PREMIUM_FEATURE_MODAL_DATA = "PREMIUM_FEATURE_MODAL_DATA";
export const PREMIUM_FEATURE_CLOSE_MODAL = "PREMIUM_FEATURE_CLOSE_MODAL";

export const PREMIUM_GUEST_MODAL_DATA = "PREMIUM_GUEST_MODAL_DATA";
export const PREMIUM_GUEST_CLOSE_MODAL = "PREMIUM_GUEST_CLOSE_MODAL";

export const CHANGE_ACCESS_DENIED_SHOW_WARNING =
  "CHANGE_ACCESS_DENIED_SHOW_WARNING";
export const CHANGE_ACCESS_DENIED_CLOSE_WARNING =
  "CHANGE_ACCESS_DENIED_CLOSE_WARNING";

export const PANEL_SELECTION_MODAL_DATA = "PANEL_SELECTION_MODAL_DATA";
export const PANEL_SELECTION_CLOSE_MODAL = "PANEL_SELECTION_CLOSE_MODAL";

export const PETTY_CASHIER_SELECTION_MODAL_DATA =
  "PETTY_CASHIER_SELECTION_MODAL_DATA";
export const PETTY_CASHIER_SELECTION_CLOSE_MODAL =
  "PETTY_CASHIER_SELECTION_CLOSE_MODAL";

export const SET_PROJECT_SUB_ITEMS_ADD_MODAL_INFO =
  "SET_PROJECT_SUB_ITEMS_ADD_MODAL_INFO";
export const CLOSE_PROJECT_SUB_ITEMS_ADD_MODAL =
  "CLOSE_PROJECT_SUB_ITEMS_ADD_MODAL";

export const SET_PROJECT_TEAM_SUB_ITEMS_MANAGEMENT_MODAL_INFO =
  "SET_PROJECT_TEAM_SUB_ITEMS_MANAGEMENT_MODAL_INFO";
export const CLOSE_PROJECT_TEAM_SUB_ITEMS_MANAGEMENT_MODAL =
  "CLOSE_PROJECT_TEAM_SUB_ITEMS_MANAGEMENT_MODAL";

export const SET_TEAM_SHOW_CONFIRM_DATA = "SET_TEAM_SHOW_CONFIRM_DATA";

export const GET_TEAMS_LIST_REQUEST = "GET_TEAMS_LIST_REQUEST";
export const GET_TEAMS_LIST_SUCCESS = "GET_TEAMS_LIST_SUCCESS";
export const GET_TEAMS_LIST_FAILURE = "GET_TEAMS_LIST_FAILURE";

export const SHOW_TEAM_REQUEST = "SHOW_TEAM_REQUEST";
export const SHOW_TEAM_SUCCESS = "SHOW_TEAM_SUCCESS";
export const SHOW_TEAM_FAILURE = "SHOW_TEAM_FAILURE";

export const GET_TEAM_LEVELS_REQUEST = "GET_TEAM_LEVELS_REQUEST";
export const GET_TEAM_LEVELS_SUCCESS = "GET_TEAM_LEVELS_SUCCESS";
export const GET_TEAM_LEVELS_FAILURE = "GET_TEAM_LEVELS_FAILURE";

export const REORDER_TEAM_LEVELS_REQUEST = "REORDER_TEAM_LEVELS_REQUEST";
export const REORDER_TEAM_LEVELS_SUCCESS = "REORDER_TEAM_LEVELS_SUCCESS";
export const REORDER_TEAM_LEVELS_FAILURE = "REORDER_TEAM_LEVELS_FAILURE";

export const REMOVE_TEAM_REQUEST = "REMOVE_TEAM_REQUEST";
export const REMOVE_TEAM_SUCCESS = "REMOVE_TEAM_SUCCESS";
export const REMOVE_TEAM_FAILURE = "REMOVE_TEAM_FAILURE";

export const STORE_TEAM_REQUEST = "STORE_TEAM_REQUEST";
export const STORE_TEAM_SUCCESS = "STORE_TEAM_SUCCESS";
export const STORE_TEAM_FAILURE = "STORE_TEAM_FAILURE";

export const UPDATE_TEAM_REQUEST = "UPDATE_TEAM_REQUEST";
export const UPDATE_TEAM_SUCCESS = "UPDATE_TEAM_SUCCESS";
export const UPDATE_TEAM_FAILURE = "UPDATE_TEAM_FAILURE";

export const SET_TEAM_MODAL_DATA = "SET_TEAM_MODAL_DATA";
export const CLOSE_TEAM_MODAL = "CLOSE_TEAM_MODAL";

export const CLEAR_LAST_ADDED_TEAM = "CLEAR_LAST_ADDED_TEAM";

export const REMOVE_TEAM_LEVEL_REQUEST = "REMOVE_TEAM_LEVEL_REQUEST";
export const REMOVE_TEAM_LEVEL_SUCCESS = "REMOVE_TEAM_LEVEL_SUCCESS";
export const REMOVE_TEAM_LEVEL_FAILURE = "REMOVE_TEAM_LEVEL_FAILURE";

export const STORE_TEAM_LEVEL_REQUEST = "STORE_TEAM_LEVEL_REQUEST";
export const STORE_TEAM_LEVEL_SUCCESS = "STORE_TEAM_LEVEL_SUCCESS";
export const STORE_TEAM_LEVEL_FAILURE = "STORE_TEAM_LEVEL_FAILURE";

export const SHOW_TEAM_LEVEL_REQUEST = "SHOW_TEAM_LEVEL_REQUEST";
export const SHOW_TEAM_LEVEL_SUCCESS = "SHOW_TEAM_LEVEL_SUCCESS";
export const SHOW_TEAM_LEVEL_FAILURE = "SHOW_TEAM_LEVEL_FAILURE";

export const UPDATE_TEAM_LEVEL_REQUEST = "UPDATE_TEAM_LEVEL_REQUEST";
export const UPDATE_TEAM_LEVEL_SUCCESS = "UPDATE_TEAM_LEVEL_SUCCESS";
export const UPDATE_TEAM_LEVEL_FAILURE = "UPDATE_TEAM_LEVEL_FAILURE";

export const SET_TEAM_LEVEL_MODAL_DATA = "SET_TEAM_LEVEL_MODAL_DATA";
export const CLOSE_TEAM_LEVEL_MODAL = "CLOSE_TEAM_LEVEL_MODAL";

export const REMOVE_TEAM_LEVEL_APPROVER_REQUEST =
  "REMOVE_TEAM_LEVEL_APPROVER_REQUEST";
export const REMOVE_TEAM_LEVEL_APPROVER_SUCCESS =
  "REMOVE_TEAM_LEVEL_APPROVER_SUCCESS";
export const REMOVE_TEAM_LEVEL_APPROVER_FAILURE =
  "REMOVE_TEAM_LEVEL_APPROVER_FAILURE";

export const GET_TEAM_LEVEL_APPROVERS_REQUEST =
  "GET_TEAM_LEVEL_APPROVERS_REQUEST";
export const GET_TEAM_LEVEL_APPROVERS_SUCCESS =
  "GET_TEAM_LEVEL_APPROVERS_SUCCESS";
export const GET_TEAM_LEVEL_APPROVERS_FAILURE =
  "GET_TEAM_LEVEL_APPROVERS_FAILURE";

export const STORE_TEAM_LEVEL_APPROVER_REQUEST =
  "STORE_TEAM_LEVEL_APPROVER_REQUEST";
export const STORE_TEAM_LEVEL_APPROVER_SUCCESS =
  "STORE_TEAM_LEVEL_APPROVER_SUCCESS";
export const STORE_TEAM_LEVEL_APPROVER_FAILURE =
  "STORE_TEAM_LEVEL_APPROVER_FAILURE";

export const UPDATE_TEAM_WIDGETS_REQUEST = "UPDATE_TEAM_WIDGETS_REQUEST";
export const UPDATE_TEAM_WIDGETS_SUCCESS = "UPDATE_TEAM_WIDGETS_SUCCESS";
export const UPDATE_TEAM_WIDGETS_FAILURE = "UPDATE_TEAM_WIDGETS_FAILURE";

export const PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_REQUEST =
  "PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_REQUEST";
export const PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_SUCCESS =
  "PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_SUCCESS";
export const PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_FAILURE =
  "PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_FAILURE";

export const PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_REQUEST =
  "PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_REQUEST";
export const PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_SUCCESS =
  "PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_SUCCESS";
export const PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_FAILURE =
  "PETTY_CASHIER_SHOW_PETTY_CASH_BUDGET_BY_ACCOUNT_TITLES_FAILURE";

export const PETTY_CASHIER_VAT_REVIEW_REQUEST =
  "PETTY_CASHIER_VAT_REVIEW_REQUEST";
export const PETTY_CASHIER_VAT_REVIEW_SUCCESS =
  "PETTY_CASHIER_VAT_REVIEW_SUCCESS";
export const PETTY_CASHIER_VAT_REVIEW_FAILURE =
  "PETTY_CASHIER_VAT_REVIEW_FAILURE";

export const PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_REQUEST =
  "PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_REQUEST";
export const PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_SUCCESS =
  "PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_SUCCESS";
export const PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_FAILURE =
  "PETTY_CASHIER_GET_MONTHLY_REVIEW_BUDGET_FAILURE";
export const PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_REQUEST =
  "PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_REQUEST";
export const PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_SUCCESS =
  "PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_SUCCESS";
export const PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_FAILURE =
  "PETTY_CASHIER_GET_LIST_MONTHLY_BUDGET_FAILURE";

export const PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_REQUEST =
  "PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_REQUEST";
export const PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_SUCCESS =
  "PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_SUCCESS";
export const PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_FAILURE =
  "PETTY_CASHIER_GET_INIT_MONTHLY_BUDGET_FAILURE";

export const PETTY_CASHIER_EMPTY_MONTHLY_BUDGET_CACHED_DATA_FOR_CREATE =
  "PETTY_CASHIER_EMPTY_MONTHLY_BUDGET_CACHED_DATA_FOR_CREATE";

export const PETTY_CASHIER_STORE_MONTHLY_BUDGET_REQUEST =
  "PETTY_CASHIER_STORE_MONTHLY_BUDGET_REQUEST";
export const PETTY_CASHIER_STORE_MONTHLY_BUDGET_SUCCESS =
  "PETTY_CASHIER_STORE_MONTHLY_BUDGET_SUCCESS";
export const PETTY_CASHIER_STORE_MONTHLY_BUDGET_FAILURE =
  "PETTY_CASHIER_STORE_MONTHLY_BUDGET_FAILURE";

export const PETTY_CASHIER_SHOW_MONTHLY_BUDGET_REQUEST =
  "PETTY_CASHIER_SHOW_MONTHLY_BUDGET_REQUEST";
export const PETTY_CASHIER_SHOW_MONTHLY_BUDGET_SUCCESS =
  "PETTY_CASHIER_SHOW_MONTHLY_BUDGET_SUCCESS";
export const PETTY_CASHIER_SHOW_MONTHLY_BUDGET_FAILURE =
  "PETTY_CASHIER_SHOW_MONTHLY_BUDGET_FAILURE";

export const PETTY_CASHIER_GET_MONTHLY_BUDGET_REQUEST =
  "PETTY_CASHIER_GET_MONTHLY_BUDGET_REQUEST";
export const PETTY_CASHIER_GET_MONTHLY_BUDGET_SUCCESS =
  "PETTY_CASHIER_GET_MONTHLY_BUDGET_SUCCESS";
export const PETTY_CASHIER_GET_MONTHLY_BUDGET_FAILURE =
  "PETTY_CASHIER_GET_MONTHLY_BUDGET_FAILURE";

export const PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_REQUEST =
  "PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_REQUEST";
export const PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_SUCCESS =
  "PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_SUCCESS";
export const PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_FAILURE =
  "PETTY_CASHIER_UPDATE_MONTHLY_BUDGET_FAILURE";

export const PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_REQUEST =
  "PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_REQUEST";
export const PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_SUCCESS =
  "PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_SUCCESS";
export const PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_FAILURE =
  "PETTY_CASHIER_REMOVE_MONTHLY_BUDGET_FAILURE";

export const MANAGER_VAT_REVIEW_REQUEST = "MANAGER_VAT_REVIEW_REQUEST";
export const MANAGER_VAT_REVIEW_SUCCESS = "MANAGER_VAT_REVIEW_SUCCESS";
export const MANAGER_VAT_REVIEW_FAILURE = "MANAGER_VAT_REVIEW_FAILURE";

export const USER_MANAGEMENT_GET_USER_LIST_REQUEST =
  "USER_MANAGEMENT_GET_USER_LIST_REQUEST";
export const USER_MANAGEMENT_GET_USER_LIST_SUCCESS =
  "USER_MANAGEMENT_GET_USER_LIST_SUCCESS";
export const USER_MANAGEMENT_GET_USER_LIST_FAILURE =
  "USER_MANAGEMENT_GET_USER_LIST_FAILURE";

export const USER_MANAGEMENT_CHECK_PHONE_NUMBER_REQUEST =
  "USER_MANAGEMENT_CHECK_PHONE_NUMBER_REQUEST";
export const USER_MANAGEMENT_CHECK_PHONE_NUMBER_SUCCESS =
  "USER_MANAGEMENT_CHECK_PHONE_NUMBER_SUCCESS";
export const USER_MANAGEMENT_CHECK_PHONE_NUMBER_FAILURE =
  "USER_MANAGEMENT_CHECK_PHONE_NUMBER_FAILURE";

export const USER_MANAGEMENT_CLEAR_FETCHED_USER_DATA =
  "USER_MANAGEMENT_CLEAR_FETCHED_USER_DATA";

export const USER_MANAGEMENT_INVITE_REQUEST = "USER_MANAGEMENT_INVITE_REQUEST";
export const USER_MANAGEMENT_INVITE_SUCCESS = "USER_MANAGEMENT_INVITE_SUCCESS";
export const USER_MANAGEMENT_INVITE_FAILURE = "USER_MANAGEMENT_INVITE_FAILURE";

export const USER_MANAGEMENT_INIT_INVITE_REQUEST =
  "USER_MANAGEMENT_INIT_INVITE_REQUEST";
export const USER_MANAGEMENT_INIT_INVITE_SUCCESS =
  "USER_MANAGEMENT_INIT_INVITE_SUCCESS";
export const USER_MANAGEMENT_INIT_INVITE_FAILURE =
  "USER_MANAGEMENT_INIT_INVITE_FAILURE";

export const USER_MANAGEMENT_CLEAR_FETCHED_INIT_INVITE_DATA =
  "USER_MANAGEMENT_CLEAR_FETCHED_INIT_INVITE_DATA";

export const USER_MANAGEMENT_SAVE_LAST_SELECTED_TEAMS =
  "USER_MANAGEMENT_SAVE_LAST_SELECTED_TEAMS";
export const USER_MANAGEMENT_CLEAR_LAST_SELECTED_TEAMS =
  "USER_MANAGEMENT_CLEAR_LAST_SELECTED_TEAMS";

export const USER_MANAGEMENT_SHOW_USER_PROFILE_REQUEST =
  "USER_MANAGEMENT_SHOW_USER_PROFILE_REQUEST";
export const USER_MANAGEMENT_SHOW_USER_PROFILE_SUCCESS =
  "USER_MANAGEMENT_SHOW_USER_PROFILE_SUCCESS";
export const USER_MANAGEMENT_SHOW_USER_PROFILE_FAILURE =
  "USER_MANAGEMENT_SHOW_USER_PROFILE_FAILURE";

export const USER_MANAGEMENT_SHOW_PROJECT_PROFILE_REQUEST =
  "USER_MANAGEMENT_SHOW_PROJECT_PROFILE_REQUEST";
export const USER_MANAGEMENT_SHOW_PROJECT_PROFILE_SUCCESS =
  "USER_MANAGEMENT_SHOW_PROJECT_PROFILE_SUCCESS";
export const USER_MANAGEMENT_SHOW_PROJECT_PROFILE_FAILURE =
  "USER_MANAGEMENT_SHOW_PROJECT_PROFILE_FAILURE";

export const USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_REQUEST =
  "USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_REQUEST";
export const USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_SUCCESS =
  "USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_SUCCESS";
export const USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_FAILURE =
  "USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_FAILURE";

export const USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_REQUEST_CLONE =
  "USER_MANAGEMENT_SHOW_PROJECT_USER_PROFILE_REQUEST_CLONE";

export const USER_MANAGEMENT_CONVERT_ADMIN_TO_MANAGER_REQUEST =
  "USER_MANAGEMENT_CONVERT_ADMIN_TO_MANAGER_REQUEST";
export const USER_MANAGEMENT_CONVERT_ADMIN_TO_MANAGER_SUCCESS =
  "USER_MANAGEMENT_CONVERT_ADMIN_TO_MANAGER_SUCCESS";
export const USER_MANAGEMENT_CONVERT_ADMIN_TO_MANAGER_FAILURE =
  "USER_MANAGEMENT_CONVERT_ADMIN_TO_MANAGER_FAILURE";

export const USER_MANAGEMENT_CONVERT_MANAGER_TO_ADMIN_REQUEST =
  "USER_MANAGEMENT_CONVERT_MANAGER_TO_ADMIN_REQUEST";
export const USER_MANAGEMENT_CONVERT_MANAGER_TO_ADMIN_SUCCESS =
  "USER_MANAGEMENT_CONVERT_MANAGER_TO_ADMIN_SUCCESS";
export const USER_MANAGEMENT_CONVERT_MANAGER_TO_ADMIN_FAILURE =
  "USER_MANAGEMENT_CONVERT_MANAGER_TO_ADMIN_FAILURE";

export const USER_MANAGEMENT_REACTIVATE_REQUEST =
  "USER_MANAGEMENT_REACTIVATE_REQUEST";
export const USER_MANAGEMENT_REACTIVATE_SUCCESS =
  "USER_MANAGEMENT_REACTIVATE_SUCCESS";
export const USER_MANAGEMENT_REACTIVATE_FAILURE =
  "USER_MANAGEMENT_REACTIVATE_FAILURE";

export const USER_MANAGEMENT_DEACTIVATE_REQUEST =
  "USER_MANAGEMENT_DEACTIVATE_REQUEST";
export const USER_MANAGEMENT_DEACTIVATE_SUCCESS =
  "USER_MANAGEMENT_DEACTIVATE_SUCCESS";
export const USER_MANAGEMENT_DEACTIVATE_FAILURE =
  "USER_MANAGEMENT_DEACTIVATE_FAILURE";

export const USER_MANAGEMENT_DELETE_INVITATION_REQUEST =
  "USER_MANAGEMENT_DELETE_INVITATION_REQUEST";
export const USER_MANAGEMENT_DELETE_INVITATION_SUCCESS =
  "USER_MANAGEMENT_DELETE_INVITATION_SUCCESS";
export const USER_MANAGEMENT_DELETE_INVITATION_FAILURE =
  "USER_MANAGEMENT_DELETE_INVITATION_FAILURE";

export const USER_MANAGEMENT_REMOVE_MANAGER_FROM_TEAM_REQUEST =
  "USER_MANAGEMENT_REMOVE_MANAGER_FROM_TEAM_REQUEST";
export const USER_MANAGEMENT_REMOVE_MANAGER_FROM_TEAM_SUCCESS =
  "USER_MANAGEMENT_REMOVE_MANAGER_FROM_TEAM_SUCCESS";
export const USER_MANAGEMENT_REMOVE_MANAGER_FROM_TEAM_FAILURE =
  "USER_MANAGEMENT_REMOVE_MANAGER_FROM_TEAM_FAILURE";

export const USER_MANAGEMENT_INVITE_MANAGER_TO_OTHER_TEAMS_REQUEST =
  "USER_MANAGEMENT_INVITE_MANAGER_TO_OTHER_TEAMS_REQUEST";
export const USER_MANAGEMENT_INVITE_MANAGER_TO_OTHER_TEAMS_SUCCESS =
  "USER_MANAGEMENT_INVITE_MANAGER_TO_OTHER_TEAMS_SUCCESS";
export const USER_MANAGEMENT_INVITE_MANAGER_TO_OTHER_TEAMS_FAILURE =
  "USER_MANAGEMENT_INVITE_MANAGER_TO_OTHER_TEAMS_FAILURE";

export const USER_MANAGEMENT_CHANGE_TEAM_PERMISSIONS_REQUEST =
  "USER_MANAGEMENT_CHANGE_TEAM_PERMISSIONS_REQUEST";
export const USER_MANAGEMENT_CHANGE_TEAM_PERMISSIONS_SUCCESS =
  "USER_MANAGEMENT_CHANGE_TEAM_PERMISSIONS_SUCCESS";
export const USER_MANAGEMENT_CHANGE_TEAM_PERMISSIONS_FAILURE =
  "USER_MANAGEMENT_CHANGE_TEAM_PERMISSIONS_FAILURE";

export const USER_MANAGEMENT_GET_USER_ACCOUNTING_CODES_REQUEST =
  "USER_MANAGEMENT_GET_USER_ACCOUNTING_CODES_REQUEST";
export const USER_MANAGEMENT_GET_USER_ACCOUNTING_CODES_SUCCESS =
  "USER_MANAGEMENT_GET_USER_ACCOUNTING_CODES_SUCCESS";
export const USER_MANAGEMENT_GET_USER_ACCOUNTING_CODES_FAILURE =
  "USER_MANAGEMENT_GET_USER_ACCOUNTING_CODES_FAILURE";

export const USER_MANAGEMENT_EDIT_USER_ACCOUNTING_CODES_REQUEST =
  "USER_MANAGEMENT_EDIT_USER_ACCOUNTING_CODES_REQUEST";
export const USER_MANAGEMENT_EDIT_USER_ACCOUNTING_CODES_SUCCESS =
  "USER_MANAGEMENT_EDIT_USER_ACCOUNTING_CODES_SUCCESS";
export const USER_MANAGEMENT_EDIT_USER_ACCOUNTING_CODES_FAILURE =
  "USER_MANAGEMENT_EDIT_USER_ACCOUNTING_CODES_FAILURE";

export const USER_MANAGEMENT_EDIT_IMPREST_PAYMENT_LIMIT_REQUEST =
  "USER_MANAGEMENT_EDIT_IMPREST_PAYMENT_LIMIT_REQUEST";
export const USER_MANAGEMENT_EDIT_IMPREST_PAYMENT_LIMIT_SUCCESS =
  "USER_MANAGEMENT_EDIT_IMPREST_PAYMENT_LIMIT_SUCCESS";
export const USER_MANAGEMENT_EDIT_IMPREST_PAYMENT_LIMIT_FAILURE =
  "USER_MANAGEMENT_EDIT_IMPREST_PAYMENT_LIMIT_FAILURE";

export const USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_REQUEST =
  "USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_REQUEST";
export const USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_SUCCESS =
  "USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_SUCCESS";
export const USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_FAILURE =
  "USER_MANAGEMENT_GET_USER_IMPREST_PAYMENT_FAILURE";

export const USER_MANAGEMENT_GET_SHARED_PROJECTS_REQUEST =
  "USER_MANAGEMENT_GET_SHARED_PROJECTS_REQUEST";
export const USER_MANAGEMENT_GET_SHARED_PROJECTS_SUCCESS =
  "USER_MANAGEMENT_GET_SHARED_PROJECTS_SUCCESS";
export const USER_MANAGEMENT_GET_SHARED_PROJECTS_FAILURE =
  "USER_MANAGEMENT_GET_SHARED_PROJECTS_FAILURE";

export const USER_MANAGEMENT_SHOW_MENU_MODAL =
  "USER_MANAGEMENT_SHOW_MENU_MODAL";
export const USER_MANAGEMENT_CLOSE_MENU_MODAL =
  "USER_MANAGEMENT_CLOSE_MENU_MODAL";

export const USER_MANAGEMENT_SET_CONFIRM_DATA =
  "USER_MANAGEMENT_SET_CONFIRM_DATA";
export const USER_MANAGEMENT_CLOSE_CONFIRM = "USER_MANAGEMENT_CLOSE_CONFIRM";

export const MANAGER_DASHBOARD_GET_PENDING_LIST_REQUEST =
  "MANAGER_DASHBOARD_GET_PENDING_LIST_REQUEST";
export const MANAGER_DASHBOARD_GET_PENDING_LIST_SUCCESS =
  "MANAGER_DASHBOARD_GET_PENDING_LIST_SUCCESS";
export const MANAGER_DASHBOARD_GET_PENDING_LIST_FAILURE =
  "MANAGER_DASHBOARD_GET_PENDING_LIST_FAILURE";
export const MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_REQUEST =
  "MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_REQUEST";
export const MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_SUCCESS =
  "MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_SUCCESS";
export const MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_FAILURE =
  "MANAGER_DASHBOARD_GET_CUSTODIAN_BALANCE_FAILURE";

export const MANAGER_GET_LIST_PETTY_CASH_BUDGET_REQUEST =
  "MANAGER_GET_LIST_PETTY_CASH_BUDGET_REQUEST";
export const MANAGER_GET_LIST_PETTY_CASH_BUDGET_SUCCESS =
  "MANAGER_GET_LIST_PETTY_CASH_BUDGET_SUCCESS";
export const MANAGER_GET_LIST_PETTY_CASH_BUDGET_FAILURE =
  "MANAGER_GET_LIST_PETTY_CASH_BUDGET_FAILURE";

export const MANAGER_GET_INIT_PETTY_CASH_BUDGET_REQUEST =
  "MANAGER_GET_INIT_PETTY_CASH_BUDGET_REQUEST";
export const MANAGER_GET_INIT_PETTY_CASH_BUDGET_SUCCESS =
  "MANAGER_GET_INIT_PETTY_CASH_BUDGET_SUCCESS";
export const MANAGER_GET_INIT_PETTY_CASH_BUDGET_FAILURE =
  "MANAGER_GET_INIT_PETTY_CASH_BUDGET_FAILURE";

export const MANAGER_EMPTY_PETTY_CASH_BUDGET_CACHED_DATA_FOR_CREATE =
  "MANAGER_EMPTY_PETTY_CASH_BUDGET_CACHED_DATA_FOR_CREATE";

export const MANAGER_STORE_PETTY_CASH_BUDGET_REQUEST =
  "MANAGER_STORE_PETTY_CASH_BUDGET_REQUEST";
export const MANAGER_STORE_PETTY_CASH_BUDGET_SUCCESS =
  "MANAGER_STORE_PETTY_CASH_BUDGET_SUCCESS";
export const MANAGER_STORE_PETTY_CASH_BUDGET_FAILURE =
  "MANAGER_STORE_PETTY_CASH_BUDGET_FAILURE";

export const MANAGER_SHOW_PETTY_CASH_BUDGET_REQUEST =
  "MANAGER_SHOW_PETTY_CASH_BUDGET_REQUEST";
export const MANAGER_SHOW_PETTY_CASH_BUDGET_SUCCESS =
  "MANAGER_SHOW_PETTY_CASH_BUDGET_SUCCESS";
export const MANAGER_SHOW_PETTY_CASH_BUDGET_FAILURE =
  "MANAGER_SHOW_PETTY_CASH_BUDGET_FAILURE";

export const MANAGER_GET_PETTY_CASH_BUDGET_REQUEST =
  "MANAGER_GET_PETTY_CASH_BUDGET_REQUEST";
export const MANAGER_GET_PETTY_CASH_BUDGET_SUCCESS =
  "MANAGER_GET_PETTY_CASH_BUDGET_SUCCESS";
export const MANAGER_GET_PETTY_CASH_BUDGET_FAILURE =
  "MANAGER_GET_PETTY_CASH_BUDGET_FAILURE";

export const MANAGER_UPDATE_PETTY_CASH_BUDGET_REQUEST =
  "MANAGER_UPDATE_PETTY_CASH_BUDGET_REQUEST";
export const MANAGER_UPDATE_PETTY_CASH_BUDGET_SUCCESS =
  "MANAGER_UPDATE_PETTY_CASH_BUDGET_SUCCESS";
export const MANAGER_UPDATE_PETTY_CASH_BUDGET_FAILURE =
  "MANAGER_UPDATE_PETTY_CASH_BUDGET_FAILURE";

export const MANAGER_REMOVE_PETTY_CASH_BUDGET_REQUEST =
  "MANAGER_REMOVE_PETTY_CASH_BUDGET_REQUEST";
export const MANAGER_REMOVE_PETTY_CASH_BUDGET_SUCCESS =
  "MANAGER_REMOVE_PETTY_CASH_BUDGET_SUCCESS";
export const MANAGER_REMOVE_PETTY_CASH_BUDGET_FAILURE =
  "MANAGER_REMOVE_PETTY_CASH_BUDGET_FAILURE";

export const PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_REQUEST =
  "PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_REQUEST";
export const PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_SUCCESS =
  "PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_SUCCESS";
export const PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_FAILURE =
  "PETTY_CASHIER_GET_CURRENT_PETTY_CASH_BUDGET_COMPARISON_INFO_FAILURE";

export const ACCOUNT_TITLE_LEVEL_UPDATE_REQUEST =
  "ACCOUNT_TITLE_LEVEL_UPDATE_REQUEST";
export const ACCOUNT_TITLE_LEVEL_UPDATE_SUCCESS =
  "ACCOUNT_TITLE_LEVEL_UPDATE_SUCCESS";
export const ACCOUNT_TITLE_LEVEL_UPDATE_FAILURE =
  "ACCOUNT_TITLE_LEVEL_UPDATE_FAILURE";

export const USE_IMPREST_SEQUENCE_REQUEST = "USE_IMPREST_SEQUENCE_REQUEST";
export const USE_IMPREST_SEQUENCE_SUCCESS = "USE_IMPREST_SEQUENCE_SUCCESS";
export const USE_IMPREST_SEQUENCE_FAILURE = "USE_IMPREST_SEQUENCE_FAILURE";

export const CONNECT_WITH_API_REQUEST = "CONNECT_WITH_API_REQUEST";
export const CONNECT_WITH_API_SUCCESS = "CONNECT_WITH_API_SUCCESS";
export const CONNECT_WITH_API_FAILURE = "CONNECT_WITH_API_FAILURE";

export const CONNECT_TO_PARTNER_REQUEST = "CONNECT_TO_PARTNER_REQUEST";
export const CONNECT_TO_PARTNER_SUCCESS = "CONNECT_TO_PARTNER_SUCCESS";
export const CONNECT_TO_PARTNER_FAILURE = "CONNECT_TO_PARTNER_FAILURE";

export const REMOVE_SUB_ACCOUNT_TITLE_REQUEST =
  "REMOVE_SUB_ACCOUNT_TITLE_REQUEST";
export const REMOVE_SUB_ACCOUNT_TITLE_SUCCESS =
  "REMOVE_SUB_ACCOUNT_TITLE_SUCCESS";
export const REMOVE_SUB_ACCOUNT_TITLE_FAILURE =
  "REMOVE_SUB_ACCOUNT_TITLE_FAILURE";
export const STORE_SUB_ACCOUNT_TITLE_REQUEST =
  "STORE_SUB_ACCOUNT_TITLE_REQUEST";
export const STORE_SUB_ACCOUNT_TITLE_SUCCESS =
  "STORE_SUB_ACCOUNT_TITLE_SUCCESS";
export const STORE_SUB_ACCOUNT_TITLE_FAILURE =
  "STORE_SUB_ACCOUNT_TITLE_FAILURE";
export const UPDATE_SUB_ACCOUNT_TITLE_REQUEST =
  "UPDATE_SUB_ACCOUNT_TITLE_REQUEST";
export const UPDATE_SUB_ACCOUNT_TITLE_SUCCESS =
  "UPDATE_SUB_ACCOUNT_TITLE_SUCCESS";
export const UPDATE_SUB_ACCOUNT_TITLE_FAILURE =
  "UPDATE_SUB_ACCOUNT_TITLE_FAILURE";
